import { Component } from 'react';
import Icon from 'noc/components/icon';
import ColumnFilterHeader from 'noc/components/column-filter-header';
import TextBoxFilter from 'noc/components/text-box-filter';

export class FilterInputPopup extends Component {
    render() {
        const { filterDisplayName,
            filterName,
            filterId,
            tabsData,
            requestForId,
            index,
            onCheckedOfColumnFilter,
            onTextFilter,
            getFilteredData,
            toggle,
            columnFilters,
            filteredDataColumns
        } = this.props;

        const tabData = tabsData.find(x => x.Id === requestForId);
        const filter = tabData.QueueViewGrid.GridFilters.find(x => x.FilterName === filterName);
        return (
            <li className="cn-filterset__opt" key={index}>
                <span>
                    <a
                        className="cn-filter__link" href="javascript:;"
                        onClick={() => { toggle(columnFilters, filterName); }}
                        ref={this.assignButton}
                    >
                        <span className="cn-filter__label">{filterDisplayName}</span>
                        <span className="cn-filter__value">{this.renderValue(filterId, tabData.Id)}</span>
                        <Icon type="cn-icon--menu" icon="icon-triangle-down" />
                    </a>
                    {filter.FilterValue === 'MultiSelect' ?
                        <ColumnFilterHeader
                            filterDisplayName={filterDisplayName}
                            filterName={filterName}
                            requestForId={requestForId}
                            isFilter
                            tabsData={tabsData}
                            onCheckedOfColumnFilter={onCheckedOfColumnFilter}
                            filterId={filterId}
                            columnFilters={columnFilters}
                            filteredDataColumns={filteredDataColumns}
                        /> :
                        <TextBoxFilter
                            filterDisplayName={filterDisplayName}
                            filterName={filterName}
                            requestForId={requestForId}
                            isFilter
                            tabsData={tabsData}
                            onTextFilter={onTextFilter}
                            getFilteredData={getFilteredData}
                            filterId={filterId}
                            columnFilters={columnFilters}
                            toggle={toggle}
                        /> }
                </span>
            </li>
        );
    }

    renderValue(filterId, requestForId) {
        const { tabsData } = this.props;
        let strSelected = null;
        const tabData = tabsData.find(x => x.Id === requestForId);
        const filterData = tabData.QueueViewGrid.GridFilters.find(x => x.FilterId === filterId);
        if (filterData !== undefined) {
            tabData.AdvanceSearch.map((data, k) => {
                if (filterData.FilterName === data.PropertyName) {
                    if (filterData.FilterValue === 'MultiSelect') {
                        const filter = filterData.FilterData.find(x => x.Id === data.PropertyValue);
                        if (filter !== undefined) {
                            strSelected = strSelected === null ? filter.DisplayName : `${strSelected}, ${filter.DisplayName}`;
                        }
                    } else {
                        strSelected = data.PropertyValue;
                    }
                }
            });
            if (strSelected != null) {
                if (strSelected.split(',').length > 2) {
                    strSelected = `${strSelected.split(', ').length} Selected`;
                }
            }
        }
        return (strSelected);
    }
}
export default FilterInputPopup;



// WEBPACK FOOTER //
// ./app/components/filter-input-popup.jsx